import "./App.css";
import React from "react";
import AppRoutes from "./routes/appRoutes";
import { BrowserRouter as Router } from 'react-router-dom';
import "./assets/css/animate.css";

const App = () => {
    document.documentElement.lang = 'fa';
    document.documentElement.dir = 'rtl';
    return (
        <Router>
            <AppRoutes />
        </Router>
    );
};

export default App;